import * as React from 'react';
import { IMenuProps } from './menu-props.interface';
import { DesktopMenu } from './desktop-menu';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { MobileMenu } from './mobile-menu';
import { HamburgerMenu } from './hamburger-menu';

@inject('state')
@observer
export class Menu extends React.Component<IMenuProps & IInjectedProps> {
  render() {
    let MenuClass = DesktopMenu;
    if (this.props.state.configuration.isMobile) {
      MenuClass = MobileMenu;
    } else if (this.props.menuStyle === 'dropdown') {
      MenuClass = HamburgerMenu;
    }
    return <MenuClass {...this.props} />;
  }
}